module.exports = __webpack_public_path__ + "img/slide08_mob.21de26ea.jpg";